import React from 'react'
import $ from 'jquery';
/*  Carousel, */
/* import ItemsCarousel from 'react-items-carousel'; */
import Partners from './components/partners';
import TopCarousel from './components/topCarousel';
import News from './components/newsSection';
import { Helmet } from 'react-helmet';
import Clients from './components/clients';
export default class home extends React.Component {
  constructor(props) {
    super(props);

  }

  render() {

    return (

      <div className="container-fluid ">

        <div className="row">
          <TopCarousel />


        </div>

        <div className="row  py-5">
          <div className="col-12">
            <h1 className="block-title text-center title mb-5 mt-5">
              شركاء هاد </h1>
          </div>
          {/* <div className="col-12 col-md-6 mx-auto">
                <ClientsCarousel/>
            </div> */}
          <div className="container ">
            <div className="row">
              <div className="col-12">
                <Partners />
              </div>
            </div>
          </div>
        </div>
        {/* <div className="col-12">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none" className="home-divider">
              <polygon  points="0,100 100,0 100,100"/>
            </svg>
            </div> */}


        <div className="row  py-5 bg-alt">

          <div className="col-12">
            <h1 className="block-title text-center title mb-5 mt-5">
              عملاء هاد </h1>
          </div>
          {/* <div className="col-12 col-md-6 mx-auto">
              <ClientsCarousel/>
            </div> */}

          <div className="container ">
            <div className="row">
              <div className="col-12">
                <Clients />
              </div>
            </div>
          </div>
        </div>


        <div className="row py-5 ">
          <div className="col-12">
            <div className="custom-shape-divider-top-1608273274">
              <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
              </svg>
            </div>


          </div>
          <div className="col-12">
            <h1 className="block-title text-center title mb-5 mt-5">
              الأخبار </h1>
          </div>
          <div className="container">


            <News />

          </div>
        </div>

      </div>
    )


  }
}
